import { lazy, Suspense } from "react";
import styles from "./SiteMap.module.css";

const SiteMapInner = lazy(() =>
  import("./SiteMap").then((mod) => ({ default: mod.SiteMapInner })),
);

function MapFallback() {
  return (
    <div className={styles.wrapper}>
      <div className={styles.map} />
    </div>
  );
}

interface SiteMapProps {
  readonly latitude?: number | null;
  readonly longitude?: number | null;
  readonly radiusMetres?: number;
  readonly onLocationChange?: (lat: number, lng: number) => void;
}

export function SiteMap(props: SiteMapProps) {
  return (
    <Suspense fallback={<MapFallback />}>
      <SiteMapInner {...props} />
    </Suspense>
  );
}
